exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download-icon[data-v-f6abfcc8] {\n  color: #3879eb;\n  font-weight: bold;\n}", ""]);

// exports
